/* Pumped Ducks interactions */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    initAll();
    document.addEventListener('shopify:section:load', initAll);
  });

  /* Cart drawer */
  function drawerSet(open) {
    var d = document.querySelector('[data-cart-drawer]');
    var o = document.querySelector('[data-cart-overlay]');
    if (!d) return;
    d.classList.toggle('open', open);
    if (o) o.classList.toggle('open', open);
    document.documentElement.classList.toggle('drawer-lock', open);
  }
  function drawerRefresh(open) {
    return fetch('/?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (data) {
      var sec = document.getElementById('shopify-section-cart-drawer');
      if (sec && data['cart-drawer']) {
        var tmp = document.createElement('div');
        tmp.innerHTML = data['cart-drawer'];
        sec.innerHTML = tmp.firstElementChild ? tmp.firstElementChild.innerHTML : data['cart-drawer'];
      }
      var d = document.querySelector('[data-cart-drawer]');
      var count = d ? Number(d.getAttribute('data-count') || 0) : 0;
      document.querySelectorAll('.cart-bubble').forEach(function (b) {
        b.textContent = count;
        b.style.display = count > 0 ? '' : 'none';
      });
      if (open) drawerSet(true);
    }).catch(function () { if (open) window.location.href = '/cart'; });
  }
  window.PDCart = { refresh: drawerRefresh, open: function () { drawerSet(true); } };
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { drawerSet(false); searchSet(false); } });
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-cart-toggle],[data-cart-close],[data-cart-overlay],[data-qty-change],[data-line-remove]') : null;
    if (!t) return;
    if (t.hasAttribute('data-cart-toggle')) { e.preventDefault(); searchSet(false); drawerSet(true); }
    else if (t.hasAttribute('data-cart-close') || t.hasAttribute('data-cart-overlay')) { drawerSet(false); }
    else {
      var line = Number(t.getAttribute('data-line'));
      var qty = 0;
      if (t.hasAttribute('data-qty-change')) {
        var span = t.parentNode.querySelector('span');
        qty = Math.max(0, Number(span ? span.textContent : 1) + Number(t.getAttribute('data-qty-change')));
      }
      var item = t.closest('.cart-drawer__item');
      if (item) item.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function () { drawerRefresh(true); });
    }
  });

  /* Search drawer */
  function searchSet(open) {
    var d = document.querySelector('[data-search-drawer]');
    var o = document.querySelector('[data-search-overlay]');
    if (!d) return;
    d.classList.toggle('open', open);
    if (o) o.classList.toggle('open', open);
    document.documentElement.classList.toggle('drawer-lock', open);
    if (open) { var inp = d.querySelector('[data-search-input]'); if (inp) setTimeout(function () { inp.focus(); }, 80); }
  }
  var searchTimer = null;
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-search-toggle],[data-search-close],[data-search-overlay]') : null;
    if (!t) return;
    e.preventDefault();
    if (t.hasAttribute('data-search-toggle')) { drawerSet(false); searchSet(true); }
    else searchSet(false);
  });
  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-search-input]')) return;
    var q = e.target.value.trim();
    var res = document.querySelector('[data-search-results]');
    if (!res) return;
    clearTimeout(searchTimer);
    if (!q) { res.innerHTML = '<div class="search-drawer__hint">Start typing to search.</div>'; return; }
    searchTimer = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var prods = (((data || {}).resources || {}).results || {}).products || [];
          if (!prods.length) { res.innerHTML = '<div class="search-drawer__hint">No products found for \u201C' + q.replace(/</g, '&lt;') + '\u201D.</div>'; return; }
          var cur = document.querySelector('[data-search-drawer]').getAttribute('data-currency') || '$';
          var html = prods.map(function (p) {
            var img = '';
            if (p.featured_image && p.featured_image.url) img = p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=160';
            return '<a class="search-hit" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="">' : '<span class="search-hit__noimg"></span>') + '<span class="search-hit__name">' + p.title.replace(/</g, '&lt;') + '</span><span class="search-hit__price">' + cur + p.price + '</span></a>';
          }).join('');
          html += '<a class="search-drawer__all" href="/search?q=' + encodeURIComponent(q) + '">See all results</a>';
          res.innerHTML = html;
        }).catch(function () {});
    }, 250);
  });

  function initAll() {
    var burger = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    var overlay = document.querySelector('[data-menu-overlay]');
    var closeBtn = document.querySelector('[data-menu-close]');
    function setMenu(open) {
      if (menu) menu.classList.toggle('open', open);
      if (overlay) overlay.classList.toggle('open', open);
    }
    if (burger && menu && !burger.dataset.pdBound) { burger.dataset.pdBound = '1'; burger.addEventListener('click', function () { setMenu(!menu.classList.contains('open')); }); }
    if (overlay && !overlay.dataset.pdBound) { overlay.dataset.pdBound = '1'; overlay.addEventListener('click', function () { setMenu(false); }); }
    if (closeBtn && !closeBtn.dataset.pdBound) { closeBtn.dataset.pdBound = '1'; closeBtn.addEventListener('click', function () { setMenu(false); }); }

    /* Transparent header -> white on scroll (home) */
    var header = document.querySelector('.header');
    if (header && !header.dataset.pdBound) {
      header.dataset.pdBound = '1';
      var onScroll = function () { header.classList.toggle('scrolled', (window.scrollY || 0) > 40); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* Quick add: + reveals size tray; size click adds variant to cart */
    function bindQuickSize(btn) {
      if (btn.dataset.pdBound) return;
      btn.dataset.pdBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var variantId = btn.getAttribute('data-variant-id');
        if (variantId) {
          btn.classList.add('added');
          var orig = btn.textContent;
          btn.textContent = '\u2713';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 })
          }).then(function (r) {
            if (!r.ok) throw new Error('add failed');
            drawerRefresh(true);
            setTimeout(function () {
              btn.classList.remove('added');
              btn.textContent = orig;
              var tray = btn.closest('[data-quick-tray]');
              if (tray) tray.classList.remove('open');
            }, 900);
          }).catch(function () {
            btn.classList.remove('added');
            btn.textContent = orig;
          });
        } else if (btn.getAttribute('data-href')) {
          window.location.href = btn.getAttribute('data-href');
        }
      });
    }
    document.querySelectorAll('[data-quick-card]').forEach(function (card) {
      if (card.dataset.pdBound) return;
      card.dataset.pdBound = '1';
      var toggle = card.querySelector('[data-quick-toggle]');
      var tray = card.querySelector('[data-quick-tray]');
      var close = card.querySelector('[data-quick-close]');
      if (!toggle || !tray) return;
      function stop(e) { e.preventDefault(); e.stopPropagation(); }
      toggle.addEventListener('click', function (e) { stop(e); tray.classList.add('open'); });
      if (close) close.addEventListener('click', function (e) { stop(e); tray.classList.remove('open'); });
      tray.querySelectorAll('[data-quick-size]').forEach(bindQuickSize);
    });

    /* Color swatches: variant swatches jump to variant image; colorway swatches swap the whole card */
    document.querySelectorAll('.prod-card').forEach(function (cardEl) {
      if (cardEl.dataset.pdSwBound) return;
      cardEl.dataset.pdSwBound = '1';
      var img = cardEl.querySelector('.prod-card__img > img:not(.img-hover)');
      var hover = cardEl.querySelector('.img-hover');
      var swatches = cardEl.querySelectorAll('[data-swatch]');
      if (swatches.length) {
        var defaultSrc = img ? img.getAttribute('src') : null;
        var sizeBtns = cardEl.querySelectorAll('[data-quick-size][data-color]');
        var setColor = function (sw) {
          swatches.forEach(function (s) { s.classList.toggle('active', s === sw); });
          var color = sw.getAttribute('data-color');
          var src = sw.getAttribute('data-img');
          if (img) {
            img.removeAttribute('srcset');
            img.src = src || defaultSrc;
          }
          if (hover) hover.style.display = (sw === swatches[0]) ? '' : 'none';
          sizeBtns.forEach(function (b) {
            b.style.display = b.getAttribute('data-color') === color ? '' : 'none';
          });
        };
        swatches.forEach(function (sw) {
          sw.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            setColor(sw);
          });
        });
        if (sizeBtns.length) setColor(swatches[0]);
      }
      var altData = cardEl.querySelector('[data-alt-products]');
      if (altData) {
        var alts;
        try { alts = JSON.parse(altData.textContent); } catch (err) { alts = null; }
        if (alts) {
          var altSw = cardEl.querySelectorAll('[data-alt-idx]');
          var tray = cardEl.querySelector('[data-quick-tray]');
          var trayClose = tray ? tray.querySelector('[data-quick-close]') : null;
          var nameEl = cardEl.querySelector('.prod-card__name');
          var typeEl = cardEl.querySelector('.prod-card__type');
          var priceEl = cardEl.querySelector('.prod-card__price');
          var applyAlt = function (idx) {
            var p = alts[idx];
            if (!p) return;
            altSw.forEach(function (s) { s.classList.toggle('active', Number(s.getAttribute('data-alt-idx')) === idx); });
            if (img) { img.removeAttribute('srcset'); if (p.img) img.src = p.img; }
            if (hover) {
              if (p.img2) { hover.src = p.img2; hover.style.display = ''; }
              else hover.style.display = 'none';
            }
            if (nameEl) nameEl.textContent = p.title;
            if (typeEl && p.type) typeEl.textContent = p.type;
            if (priceEl) {
              priceEl.textContent = p.price;
              if (p.was) {
                var was = document.createElement('span');
                was.className = 'prod-card__was';
                was.textContent = p.was;
                priceEl.appendChild(was);
              }
            }
            if (cardEl.tagName === 'A') cardEl.setAttribute('href', p.url);
            if (tray) {
              tray.querySelectorAll('[data-quick-size]').forEach(function (b) { b.remove(); });
              p.variants.forEach(function (v) {
                var b = document.createElement('button');
                b.type = 'button';
                b.className = 'quick-add__size';
                b.setAttribute('data-quick-size', '');
                b.setAttribute('data-variant-id', v.id);
                b.disabled = !v.available;
                b.textContent = v.label === 'Default Title' ? 'ADD' : v.label;
                tray.insertBefore(b, trayClose);
                bindQuickSize(b);
              });
            }
          };
          altSw.forEach(function (sw) {
            sw.addEventListener('click', function (e) {
              e.preventDefault(); e.stopPropagation();
              applyAlt(Number(sw.getAttribute('data-alt-idx')));
            });
          });
        }
      }
    });

    /* Bundle builder: per-item color/size selection, one-click add of all items */
    document.querySelectorAll('[data-bundle-add]').forEach(function (bundleBtn) {
      var bScope = bundleBtn.closest('.pdp-bundle, .bundle') || document;
      var bundleItems = bScope.querySelectorAll('[data-bundle-item]');
      if (!bundleItems.length || bundleBtn.dataset.pdBound) return;
      bundleBtn.dataset.pdBound = '1';
      var picks = [];
      bundleItems.forEach(function (el) {
        var dataEl = el.querySelector('[data-bundle-variants]');
        if (!dataEl) return;
        var variants;
        try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
        var img = el.querySelector('[data-bundle-img]');
        var swatches = el.querySelectorAll('[data-swatch]');
        var sizes = el.querySelectorAll('.size[data-size]');
        var pick = {
          variants: variants,
          color: swatches.length ? swatches[0].getAttribute('data-color') : null,
          size: sizes.length ? sizes[0].getAttribute('data-size') : null
        };
        function refreshSizes() {
          sizes.forEach(function (b) {
            var sz = b.getAttribute('data-size');
            var ok = variants.some(function (v) {
              return (pick.color === null || v.color === pick.color) && v.size === sz && (v.available || v.plan);
            });
            b.disabled = !ok;
            if (!ok && b.classList.contains('active')) b.classList.remove('active');
          });
          if (!el.querySelector('.size.active')) {
            var first = Array.prototype.find.call(sizes, function (b) { return !b.disabled; });
            if (first) { first.classList.add('active'); pick.size = first.getAttribute('data-size'); }
            else pick.size = null;
          }
        }
        swatches.forEach(function (sw) {
          sw.addEventListener('click', function () {
            swatches.forEach(function (s) { s.classList.toggle('active', s === sw); });
            pick.color = sw.getAttribute('data-color');
            var v = variants.find(function (x) { return x.color === pick.color && x.img; });
            if (img && v) img.src = v.img;
            refreshSizes();
            bundleLabel();
          });
        });
        sizes.forEach(function (b) {
          b.addEventListener('click', function () {
            if (b.disabled) return;
            sizes.forEach(function (s) { s.classList.toggle('active', s === b); });
            pick.size = b.getAttribute('data-size');
            bundleLabel();
          });
        });
        if (sizes.length) refreshSizes();
        picks.push(pick);
      });
      function bundleVariant(p) {
        return p.variants.find(function (x) {
          return (p.color === null || x.color === p.color) && (p.size === null || x.size === p.size) && (x.available || x.plan);
        });
      }
      var bLine = bundleBtn.querySelector('.btn__line');
      var bSub = bundleBtn.querySelector('.btn__sub');
      var bLineHtml = bLine ? bLine.innerHTML : '';
      var bSubHtml = bSub ? bSub.innerHTML : '';
      function bundleLabel() {
        var pre = picks.some(function (p) { var v = bundleVariant(p); return v && v.plan; });
        if (bLine) bLine.innerHTML = pre ? bLineHtml.replace('Add Bundle to Cart', 'Pre-Order Bundle') : bLineHtml;
        if (bSub) bSub.innerHTML = pre ? '<span class="stock-dot stock-dot--pre"></span><b>' + (bundleBtn.getAttribute('data-bundle-pre-note') || 'Pre-order') + '</b>' : bSubHtml;
      }
      bundleLabel();
      if (picks.length === bundleItems.length) {
        bundleBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var ids = [];
          for (var i = 0; i < picks.length; i++) {
            var p = picks[i];
            var v = bundleVariant(p);
            if (!v) { alert('One of the bundle items is out of stock in the selected size.'); return; }
            var line = { id: v.id, quantity: 1 };
            if (v.plan) line.selling_plan = v.plan;
            ids.push(line);
          }
          bundleBtn.style.opacity = '0.6';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: ids })
          }).then(function (r) {
            if (!r.ok) throw new Error('add failed');
            bundleBtn.style.opacity = '';
            drawerRefresh(true);
          }).catch(function () {
            bundleBtn.style.opacity = '';
            window.location.href = bundleBtn.getAttribute('href');
          });
        });
      }
    });

    /* PDP: variant picking, tiers */
    var pdp = document.querySelector('[data-pdp]');
    if (pdp && !pdp.dataset.pdpBound) {
      pdp.dataset.pdpBound = '1';
      pdp.querySelectorAll('.pdp__photo--video video').forEach(function (v) {
        v.setAttribute('playsinline', '');
        v.muted = true;
      });
      var pVarsEl = pdp.querySelector('[data-pdp-variants]');
      var pVars = [];
      try { pVars = pVarsEl ? JSON.parse(pVarsEl.textContent) : []; } catch (e) {}
      var idInput = pdp.querySelector('[data-pdp-id]');
      var qtyInput = pdp.querySelector('[data-pdp-qty]');
      var atcBtn = pdp.querySelector('[data-pdp-atc]');
      var pdpForm = atcBtn ? atcBtn.closest('form') : null;
      if (pdpForm && !pdpForm.dataset.pdBound) {
        pdpForm.dataset.pdBound = '1';
        pdpForm.addEventListener('submit', function (e) {
          e.preventDefault();
          if (!atcBtn || atcBtn.disabled) return;
          atcBtn.style.opacity = '0.6';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: Number(idInput.value), quantity: Number(qtyInput ? qtyInput.value : 1) || 1 })
          }).then(function (r) {
            if (!r.ok) throw new Error('add failed');
            atcBtn.style.opacity = '';
            drawerRefresh(true);
          }).catch(function () {
            atcBtn.style.opacity = '';
            pdpForm.submit();
          });
        });
      }
      var pSwatches = pdp.querySelectorAll('[data-pdp-swatch]');
      var pSizes = pdp.querySelectorAll('[data-pdp-size]');
      var firstImg = pdp.querySelector('[data-media-img]');
      var sel = { color: null, size: null };
      var cur = pVars.find(function (v) { return String(v.id) === (idInput ? String(idInput.value) : ''); }) || pVars[0];
      if (cur) { sel.color = cur.color; sel.size = cur.size; }
      function pdpFind() {
        return pVars.find(function (v) {
          return (sel.color === null || v.color === sel.color) && (sel.size === null || v.size === sel.size);
        });
      }
      function pdpRefresh() {
        pSwatches.forEach(function (s) { s.classList.toggle('active', s.getAttribute('data-color') === sel.color); });
        pSizes.forEach(function (b) {
          var sz = b.getAttribute('data-size');
          var ok = pVars.some(function (v) { return (sel.color === null || v.color === sel.color) && v.size === sz && v.available; });
          b.disabled = !ok;
          if (!ok && sz === sel.size) sel.size = null;
        });
        if (sel.size === null) {
          var firstOk = Array.prototype.find.call(pSizes, function (b) { return !b.disabled; });
          if (firstOk) sel.size = firstOk.getAttribute('data-size');
        }
        pSizes.forEach(function (b) { b.classList.toggle('active', b.getAttribute('data-size') === sel.size); });
        var v = pdpFind();
        if (v) {
          if (idInput) idInput.value = v.id;
          if (atcBtn) {
            var isPre = !!v.pre && !!document.querySelector('[data-preorder]');
            atcBtn.disabled = !v.available || isPre;
            var line = atcBtn.querySelector('.btn__line');
            var sub = atcBtn.querySelector('[data-pdp-sub]');
            var hasPre = !!document.querySelector('[data-preorder]');
            atcBtn.dataset.soldOut = (!v.available || isPre) ? '1' : '';
            if (!v.available || isPre) {
              if (line) { line.dataset.origHtml = line.dataset.origHtml || line.innerHTML; line.textContent = 'Sold Out'; }
              if (sub) {
                sub.dataset.stockHtml = sub.dataset.stockHtml || sub.innerHTML;
                sub.innerHTML = hasPre ? '<span class="stock-dot stock-dot--pre"></span><b>Available for Pre-Order</b>' : 'Sold Out';
              }
            } else {
              if (line && line.dataset.origHtml) { line.innerHTML = line.dataset.origHtml; }
              if (sub && sub.dataset.stockHtml) { sub.innerHTML = sub.dataset.stockHtml; }
            }
          }
          if (v.img && firstImg) { firstImg.removeAttribute('srcset'); firstImg.src = v.img; }
          var nativePreBtn = pdp.querySelector('[data-native-preorder]');
          if (nativePreBtn) {
            var allocation = v.selling_plans && v.selling_plans.length ? v.selling_plans[0] : null;
            nativePreBtn.hidden = !allocation;
            nativePreBtn.removeAttribute('data-selling-plan');
            if (allocation) {
              nativePreBtn.setAttribute('data-selling-plan', allocation.id);
              var prePrice = nativePreBtn.querySelector('[data-preorder-price]');
              var preCompare = nativePreBtn.querySelector('[data-preorder-compare]');
              var preNote = nativePreBtn.querySelector('[data-preorder-note]');
              if (prePrice) prePrice.textContent = allocation.price_formatted;
              if (preCompare) {
                preCompare.textContent = allocation.compare_at_formatted;
                preCompare.hidden = !allocation.discounted;
              }
              if (preNote) preNote.textContent = nativePreBtn.getAttribute('data-preorder-custom-note') || allocation.name;
            }
          }
        }
      }
      if (atcBtn && window.MutationObserver) {
        var soldGuard = function () {
          if (atcBtn.dataset.soldOut !== '1') return;
          var gl = atcBtn.querySelector('.btn__line');
          if (!gl || gl.textContent.trim() !== 'Sold Out' || !atcBtn.disabled) {
            obs.disconnect();
            if (!gl) { atcBtn.innerHTML = '<span class="btn__line"></span><span class="btn__sub" data-pdp-sub></span>'; gl = atcBtn.querySelector('.btn__line'); }
            gl.textContent = 'Sold Out';
            var gs = atcBtn.querySelector('[data-pdp-sub]');
            if (gs && document.querySelector('[data-preorder]')) gs.innerHTML = '<span class="stock-dot stock-dot--pre"></span><b>Available for Pre-Order</b>';
            atcBtn.disabled = true;
            obs.observe(atcBtn, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
          }
        };
        var obs = new MutationObserver(soldGuard);
        obs.observe(atcBtn, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
      }
      pSwatches.forEach(function (s) {
        s.addEventListener('click', function (e) { e.preventDefault(); sel.color = s.getAttribute('data-color'); pdpRefresh(); });
      });
      pSizes.forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); if (b.disabled) return; sel.size = b.getAttribute('data-size'); pdpRefresh(); });
      });
      if (pSwatches.length || pSizes.length) pdpRefresh();
      /* Desktop gallery pagination: 4 tiles per page */
      var gal = pdp.querySelector('[data-gallery]');
      var galNav = pdp.querySelector('[data-gallery-nav]');
      if (gal && galNav) {
        var tiles = Array.prototype.slice.call(gal.children);
        var per = 4, page = 0, pages = Math.ceil(tiles.length / per) || 1;
        var mob = 0;
        var lbl = galNav.querySelector('[data-gal-count]');
        var mq = window.matchMedia('(min-width: 901px)');
        var mobStep = function () { return (tiles[0] ? tiles[0].offsetWidth : gal.clientWidth) + 8; };
        var dotsWrap = galNav.querySelector('[data-gal-dots]');
        var dots = [];
        if (dotsWrap) {
          tiles.forEach(function (t, i) {
            var d = document.createElement('button');
            d.type = 'button';
            d.setAttribute('aria-label', 'Photo ' + (i + 1));
            d.addEventListener('click', function () { gal.scrollTo({ left: i * mobStep(), behavior: 'smooth' }); });
            dotsWrap.appendChild(d);
            dots.push(d);
          });
        }
        var renderGal = function () {
          var desktop = mq.matches;
          if (desktop) {
            galNav.style.display = 'none';
            tiles.forEach(function (t) { t.style.display = ''; });
          } else {
            galNav.style.display = tiles.length > 1 ? '' : 'none';
            tiles.forEach(function (t) { t.style.display = ''; });
            dots.forEach(function (d, i) { d.classList.toggle('active', i === mob); });
          }
        };
        galNav.querySelector('[data-gal-prev]').addEventListener('click', function () {
          if (!mq.matches) gal.scrollBy({ left: -mobStep(), behavior: 'smooth' });
        });
        galNav.querySelector('[data-gal-next]').addEventListener('click', function () {
          if (!mq.matches) gal.scrollBy({ left: mobStep(), behavior: 'smooth' });
        });
        gal.addEventListener('scroll', function () {
          if (mq.matches) return;
          var idx = Math.round(gal.scrollLeft / mobStep());
          idx = Math.max(0, Math.min(tiles.length - 1, idx));
          if (idx !== mob) { mob = idx; renderGal(); }
        }, { passive: true });
        if (mq.addEventListener) mq.addEventListener('change', renderGal);
        renderGal();
      }
      var preBtn = pdp.querySelector('[data-preorder]');
      if (preBtn) {
        preBtn.addEventListener('click', function () {
          var body = { quantity: 1 };
          var fixedId = preBtn.getAttribute('data-preorder-id');
          var planId = preBtn.getAttribute('data-selling-plan');
          body.id = fixedId ? Number(fixedId) : Number(idInput ? idInput.value : 0);
          var mapEl = pdp.querySelector('[data-preorder-variants]');
          if (mapEl) {
            try {
              var pv = JSON.parse(mapEl.textContent);
              var vlistEl = pdp.querySelector('[data-pdp-variants]');
              var vlist = vlistEl ? JSON.parse(vlistEl.textContent) : [];
              var curId = Number(idInput ? idInput.value : 0);
              var cur = null;
              for (var ci = 0; ci < vlist.length; ci++) if (vlist[ci].id === curId) cur = vlist[ci];
              var match = null;
              for (var pi = 0; pi < pv.length; pi++) {
                var cand = pv[pi];
                if (cur && cur.size != null && cand.size != null && cand.size !== cur.size) continue;
                if (cur && cur.color != null && cand.color != null && cand.color !== cur.color) continue;
                if (!cand.available) continue;
                match = cand; break;
              }
              if (match) { body.id = match.id; }
              else { alert('This size is not available for pre-order right now.'); return; }
            } catch (e) {}
          }
          if (planId && !fixedId) body.selling_plan = Number(planId);
          preBtn.style.opacity = '0.6';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
          }).then(function (r) {
            if (!r.ok) throw new Error('add failed');
            preBtn.style.opacity = '';
            drawerRefresh(true);
          }).catch(function () {
            preBtn.style.opacity = '';
            alert('Could not add the pre-order item. Check the pre-order setup.');
          });
        });
      }
    }

    document.querySelectorAll('.sizes').forEach(function (group) {
      if (group.dataset.pdBound) return;
      group.dataset.pdBound = '1';
      group.querySelectorAll('.size').forEach(function (s) {
        s.addEventListener('click', function () {
          group.querySelectorAll('.size').forEach(function (x) { x.classList.remove('active'); });
          s.classList.add('active');
        });
      });
    });

    /* Collection filters: auto-apply on change */
    var ff = document.querySelector('[data-filter-form]');
    if (ff && !ff.dataset.pdBound) {
      ff.dataset.pdBound = '1';
      ff.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'number') return;
        ff.submit();
      });
    }
  }
})();

/* Collection grid density toggle */
(function(){
  var grid=document.querySelector('.coll-grid');
  var btns=document.querySelectorAll('[data-density]');
  if(!grid||!btns.length)return;
  function apply(m){grid.classList.toggle('is-roomy',m==='roomy');btns.forEach(function(b){b.classList.toggle('active',b.getAttribute('data-density')===m);});}
  var saved='default';try{saved=localStorage.getItem('pd-grid')||'default';}catch(e){}
  apply(saved);
  btns.forEach(function(b){b.addEventListener('click',function(){var m=b.getAttribute('data-density');try{localStorage.setItem('pd-grid',m);}catch(e){}apply(m);});});
})();

/* PDP: shorter column follows the scroll while the taller one scrolls normally */
(function(){
  var pdp=document.querySelector('[data-pdp]');if(!pdp)return;
  var media=pdp.querySelector('.pdp__media'),buy=pdp.querySelector('.pdp__buy');if(!media||!buy)return;
  var mq=window.matchMedia('(min-width:901px)'),head=96,gapB=24,ticking=false;
  function update(){
    ticking=false;
    [media,buy].forEach(function(c){c.style.position='relative';c.style.top='0';});
    if(!mq.matches){media.style.transform=buy.style.transform='';return;}
    media.style.transform=buy.style.transform='';
    var mh=media.offsetHeight,bh=buy.offsetHeight;
    var short=mh<bh?media:buy,tall=short===media?buy:media;
    var sh=short.offsetHeight,max=tall.offsetHeight-sh;if(max<=0)return;
    var y=window.scrollY||window.pageYOffset,vh=window.innerHeight;
    var top=short.getBoundingClientRect().top+y;
    var d=(sh+head+gapB<=vh)?(y+head-top):(y+vh-gapB-sh-top);
    d=Math.max(0,Math.min(max,d));
    short.style.transform='translateY('+Math.round(d)+'px)';
  }
  function req(){if(!ticking){ticking=true;requestAnimationFrame(update);}}
  window.addEventListener('scroll',req,{passive:true});window.addEventListener('resize',req);window.addEventListener('load',req);
  if(window.ResizeObserver){var ro=new ResizeObserver(req);ro.observe(media);ro.observe(buy);}
  req();
})();

/* Row scroll progress bars */
(function(){
  document.querySelectorAll('[data-row-scrollbar]').forEach(function(bar){
    var row=bar.parentElement.querySelector('.prod-row');
    var thumb=bar.querySelector('.row-scrollbar__thumb');
    if(!row||!thumb)return;
    function sync(){
      var max=row.scrollWidth-row.clientWidth;
      if(max<=1){bar.style.display='none';return;}
      bar.style.display='';
      var frac=row.clientWidth/row.scrollWidth;
      var w=Math.max(frac*100,8);
      thumb.style.width=w+'%';
      var travel=bar.clientWidth*(1-w/100);
      thumb.style.transform='translateX('+(max?(row.scrollLeft/max)*travel:0)+'px)';
    }
    row.addEventListener('scroll',sync,{passive:true});
    window.addEventListener('resize',sync);
    sync();
  });
})();

/* Size chart modal */
(function(){
  var open=document.querySelector('[data-size-chart-open]');
  var modal=document.querySelector('[data-size-chart]');
  if(!open||!modal||modal.dataset.scBound)return;
  modal.dataset.scBound='1';
  document.body.appendChild(modal); /* escape sticky/stacking ancestors so drawer sits above header */
  function show(){modal.hidden=false;requestAnimationFrame(function(){requestAnimationFrame(function(){modal.classList.add('is-open');});});}
  function hide(){modal.classList.remove('is-open');setTimeout(function(){modal.hidden=true;},380);}
  open.addEventListener('click',function(e){e.preventDefault();show();});
  modal.addEventListener('click',function(e){if(e.target===modal||e.target.closest('[data-size-chart-close]'))hide();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!modal.hidden)hide();});
})();

/* Size chart table: unit toggle + intersect hover */
(function(){
  var table=document.querySelector('[data-sc-table]');
  if(!table||table.dataset.scBound)return;
  table.dataset.scBound='1';
  var btns=document.querySelectorAll('[data-sc-unit]');
  btns.forEach(function(b){b.addEventListener('click',function(){
    btns.forEach(function(x){x.classList.toggle('active',x===b);});
    var toIn=b.getAttribute('data-sc-unit')==='in';
    table.querySelectorAll('td[data-cm]').forEach(function(td){
      var cm=parseFloat(td.getAttribute('data-cm'));
      if(isNaN(cm)){return;}
      td.textContent=toIn?String(Math.round(cm/2.54*10)/10):td.getAttribute('data-cm');
    });
  });});
  function clear(){table.querySelectorAll('.sc-hl,.sc-hl-cell').forEach(function(c){c.classList.remove('sc-hl','sc-hl-cell');});}
  table.addEventListener('mouseover',function(e){
    var cell=e.target.closest('td,th');if(!cell||!table.contains(cell))return;
    clear();
    var idx=cell.cellIndex,ri=cell.parentNode.rowIndex,rows=table.rows;
    for(var c=0;c<rows[ri].cells.length;c++)rows[ri].cells[c].classList.add('sc-hl');
    for(var r=0;r<rows.length;r++){if(rows[r].cells[idx])rows[r].cells[idx].classList.add('sc-hl');}
    cell.classList.remove('sc-hl');cell.classList.add('sc-hl-cell');
  });
  table.addEventListener('mouseleave',clear);
})();
